// EditQuoteDialog.js
import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Box
} from '@mui/material';
import { authFetchRequest } from './utils/api';
import { alertC } from './components/dialogService';

const EditQuoteDialog = ({ open, onClose, quote, onQuoteUpdated }) => {
  const [formData, setFormData] = useState({
    quote_name: '',
    reference_no: '',
    tags: ''
  });

  useEffect(() => {
    if (quote) {
      setFormData({
        quote_name: quote.quote_name || '',
        reference_no: quote.reference_no || '',
        tags: quote.tags || ''
      });
    }
  }, [quote]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      const payload = {
        quote_name: formData.quote_name,
        reference_no: formData.reference_no,
        tags: formData.tags,
        fkCustomerId: quote.fkCustomerId  // REQUIRED by your backend!
      };
  
      const updated = await authFetchRequest(
        `/quotes/${quote.id}`,
        payload,
        "PUT"
      );
  
      // Update the quote in the grid
      onQuoteUpdated(updated);
  
      // Close dialog
      onClose();
  
      // Success message
      await alertC("Quote updated successfully!");
    } catch (err) {
      console.error("Failed to update quote:", err);
      await alertC("Failed to update quote: " + (err.message || "Unknown error"));
    }
  };

  if (!quote) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Quote #{quote.id}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <TextField
            label="Quote Name"
            name="quote_name"
            value={formData.quote_name}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Reference No."
            name="reference_no"
            value={formData.reference_no}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Tags"
            name="tags"
            value={formData.tags}
            onChange={handleChange}
            fullWidth
            multiline
            rows={2}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditQuoteDialog;